export default "<div id=\"spreadsheet\"></div>\n<app-comments [commentConfig]=\"commentConfig\"></app-comments>";